export default __webpack_public_path__ + "static/media/master-bg.2fbeee1b.webp";